import React from "react";
import { ObjectiveTable } from "../../powerFlow/objectiveTerms";
import { inputHeader, inputCell, outputHeader, outputCell } from "./tableStyles";

interface Props {
  table: ObjectiveTable;
  /** The editor for the symbolic objective (minimize cost = …). */
  ruleEditor?: React.ReactNode;
}

/**
 * Renders one class of objective terms (e.g. P_gen) as a table: its index
 * columns and coefficient (inputs) plus the variable's value and the resulting
 * cost = coefficient × value (solver outputs). The symbolic objective is shown
 * above — editable, since every cost class is one term of that single objective.
 */
const ObjectiveTableView: React.FC<Props> = ({ table, ruleEditor }) => {
  return (
    <>
      {ruleEditor}
      <table
        style={{ borderCollapse: "separate", borderSpacing: 0, width: "100%" }}
      >
      <thead>
          <tr>
            {table.columns.map((column) => (
              <th key={column} style={inputHeader}>
                {column}
              </th>
            ))}
            <th key="__coeff" style={{ ...inputHeader, textAlign: "right" }}>
              coefficient
            </th>
            <th key="__value" style={{ ...outputHeader, textAlign: "right" }}>
              value
            </th>
            <th key="__cost" style={{ ...outputHeader, textAlign: "right" }}>
              cost
            </th>
          </tr>
        </thead>
        <tbody>
          {table.rows.map((row) => (
            <tr key={row.name}>
              {table.columns.map((column) => (
                <td key={column} style={inputCell}>
                  {String(row.indices[column] ?? "")}
                </td>
              ))}
              <td style={{ ...inputCell, textAlign: "right" }}>
                {row.coefficient}
              </td>
              <td style={{ ...outputCell, textAlign: "right" }}>
                {row.value !== undefined ? row.value.toFixed(3) : "—"}
              </td>
              <td style={{ ...outputCell, textAlign: "right" }}>
                {row.cost !== undefined ? `$${row.cost.toFixed(2)}` : "—"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

export default ObjectiveTableView;
